
import { toast } from "react-toastify";
import Services from "../services/services";
import { RoutePages, toastCustom, USD_TO_VND_RATE } from "../ultils";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const SubscriptionPriceCard = ({
    title = "ExamplePlan", // thêm thuộc tính title
    service_callback = "",
    requests_limit,
    concurrency,
    unit_price,
    price,
}) => {
    const navigate = useNavigate();

    const authStore = useSelector((state) => state.auth);

    const handleClickBuy = async () =>{
        const res = await Services.Subscription.preview(service_callback, requests_limit, null, concurrency);
        const data = await res.json();
        if (!res.ok || !data.success) {
            toast.error(`code_${res.status}: ${data.error}`);
            return;
        }
        if (!authStore.user) {
            toast.info("Please register and login to buy subscription!");
            navigate(RoutePages.AUTH.path);
            return;
        }
        toastCustom(
            <>
                Are you sure to spend ${data.data.price.toFixed(4)} for this plan?
                <br />
                Limit: {data.data.requests_limit.toLocaleString()} requests
                <br />
                Concurrency: {data.data.concurrency}
                <br />
                Duration: 31 days
                <br />
                Servce: {data.data.service.name}
                <br />
            </>,
            [
                {
                    label: "Confirm",
                    className: "bg-green-500 hover:bg-green-700 text-white",
                    onClick: () => handleConfirmBuy(),
                },
                {
                    label: "Cancel",
                    className: "bg-gray-500 hover:bg-gray-700 text-white",
                    onClick: () => toast.dismiss(),
                },
            ]
        );
    }
    
    const handleConfirmBuy = async () => {
        const res = await Services.Subscription.create(service_callback, requests_limit, null, concurrency);
        const data = await res.json();
        if (res.ok && data.success) {
            toast.success(data.message);
            navigate(RoutePages.MY_ACCESS_TOKEN.path);
        } else {
            toast.error(`code_${res.status}: ${data.error}`);
        }
    };

    return (
        <div className="shadow-xl rounded-2xl border border-blue-100 bg-gradient-to-br from-white via-blue-50 to-blue-100 p-6 transition-transform hover:scale-105 hover:shadow-2xl duration-200 min-w-[250px]">
            {/* Hiển thị title nếu có */}
            {title && (
                <div className="mb-3 text-center">
                    <span className="text-xl font-extrabold text-blue-600 tracking-wide">{title}</span>
                </div>
            )}
            <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                    <span className="font-bold text-lg text-gray-600">Requests</span>
                    <span className="font-bold text-lg text-gray-700">{requests_limit?.toLocaleString()}</span>
                </div>
                <div className="flex items-center justify-between">
                    <span className="font-bold text-sm text-gray-500">Concurrency</span>
                    <span className="font-bold text-gray-700">{concurrency}</span>
                </div>
                <div className="flex items-center justify-between">
                    <span className="font-bold text-sm text-gray-500">Duration</span>
                    <span className="font-bold text-gray-700">31 days</span>
                </div>
                <div className="flex items-center justify-between">
                    <span className="font-bold text-sm text-gray-500">Price (USD)</span>
                    <span className="font-bold text-green-600">${price?.toLocaleString()}</span>
                </div>
                <div className="flex items-center justify-between">
                    <span className="font-bold text-sm text-gray-500">Giá (VND)</span>
                    <span className="font-bold text-green-600">{(price ? price * USD_TO_VND_RATE : 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}đ</span>
                </div>
                <div className="flex items-center justify-between">
                    <span className="font-bold text-sm text-gray-500">Unit Price</span>
                    <span className="text-gray-500">${unit_price?.toLocaleString(undefined, { maximumFractionDigits: 5 })}/call</span>
                </div>
                <div className="flex items-center justify-between">
                    <span className="font-bold text-sm text-gray-500">Đơn giá</span>
                    <span className="text-gray-500">{(unit_price * USD_TO_VND_RATE).toLocaleString(undefined, { maximumFractionDigits: 2 })}đ/call</span>
                </div>
            </div>
            <div className="mt-6 flex justify-center">
                <button
                    onClick={() => handleClickBuy()}
                    className="px-6 py-2 text-white text-lg font-bold rounded-xl bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 shadow-lg transition-all duration-200 w-full"
                >
                    Buy now
                </button>
            </div>
        </div>
    );
};

export default SubscriptionPriceCard;